import PropTypes from 'prop-types';
import { useTranslations } from 'utils';

import './SupportedLogos.scss';
import { Tooltip } from '@flywire/headlessui-tailwindcss';
import { InfoCircle } from 'icons';

const Logo = ({ logo }) => {
  const src = logo.links.original.includes('svg')
    ? logo.links.original
    : logo.links.thumb;

  return <img alt={logo.name} className="Offer-logo" src={src} />;
};

Logo.propTypes = {
  logo: PropTypes.shape({
    name: PropTypes.string.isRequired,
    links: PropTypes.shape({
      original: PropTypes.string,
      thumb: PropTypes.string,
    }),
  }),
};

const LogosList = ({ logos }) => {
  const i18n = useTranslations();
  if (!logos || !logos.length) {
    return null;
  }

  const renderedLogos = logos.map(logo => <Logo logo={logo} key={logo.name} />);
  const names = logos.map(logo => <li key={logo.name}>{logo.name}</li>);

  return (
    <div className="SupportedLogos-logos">
      {i18n.t('LogosList.supports')}
      <div className="SupportedLogos-logos__box">{renderedLogos}</div>
      <ul className="SupportedLogos-logos__list">{names}</ul>
    </div>
  );
};

LogosList.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      links: PropTypes.shape({
        original: PropTypes.string,
        thumb: PropTypes.string,
      }),
    }),
  ),
};

export const SupportedLogos = ({ logos }) => {
  return (
    <Tooltip position="top" as="span">
      <Tooltip.Trigger className="inline-flex items-center appearance-none border-none bg-transparent p-0 ml-1 text-inherit hover:bg-transparent focus:outline-none">
        <InfoCircle className="size-3.5 cursor-pointer translate-y-px text-slate-500" />
      </Tooltip.Trigger>
      <Tooltip.Content>
        <LogosList logos={logos} />
      </Tooltip.Content>
    </Tooltip>
  );
};

SupportedLogos.displayName = 'SupportedLogos';
SupportedLogos.propTypes = {
  logos: PropTypes.array.isRequired,
};
